import { getDocumentStatusLabel } from "../../../helper/dataHelper";
import { getDDMMYYYFormat } from "../../../helper/dateTimeHelper";
import { useSearchParams } from "../../../hook/use-search-params";
import { useDocumentHistoryInfo } from "../hooks/document-content/use-document-history-info";

export const DetailDocumentStepInfo = () => {
  const { searchParams } = useSearchParams();
  const step = searchParams.get("step") || "";
  const stepLabel = getDocumentStatusLabel(step);
  const { uniqueDocHisByStep } = useDocumentHistoryInfo();

  const isRender = step && step !== "new" && step !== "interimpublish" && step !== "publish" && step !== "approval";

  return isRender ? (
    <div className="container">
      <div className="row" style={{ padding: 0 }}>
        {uniqueDocHisByStep.map((e: any, index: number) => (
          <div className="col-md-3" key={index}>
            <p className="font-weight-bold">Lần sửa đổi: {e.docEditionVersion}</p>
            <p>
              Người {stepLabel}:{" "}
              {e.docAssignedTo?.map((user: any, index: number) => (
                <span key={index}>{`${user.LookupValue.toString()}, `}</span>
              ))}
            </p>
            <p>
              Ngày {stepLabel}: {getDDMMYYYFormat(e.Modified)}
            </p>
          </div>
        ))}
      </div>
    </div>
  ) : (
    <></>
  );
};
